import { getLanguage } from '../localization';
import { IRequest, TRequestHeaders } from './httpClient';

export const createRequest = <D>(baseURL: string, pathname: string, queryString?: string, data?: D): IRequest => {
    return {
        url: queryString ? pathname + queryString : pathname,
        baseURL: baseURL,
        data: data,
    };
};

export const createHeaders = (contentType?: string): TRequestHeaders => {
    return {
        iso: getLanguage(),
        'Content-Type': contentType ?? 'application/json',
    };
};

export const paginationQuery = (pageNumber?: number, pageSize?: number, filter?: string, withTests?: boolean, vesselId?: number): string => {
    const queryParams: string[] = [];
    if (!!pageNumber) queryParams.push(`pageNumber=${pageNumber}`);
    if (!!pageSize) queryParams.push(`pageSize=${pageSize}`);
    if (!!filter) queryParams.push(`filter=${filter}`);
    if (!!withTests) queryParams.push(`withTests=${withTests}`);
    if (!!vesselId) queryParams.push(`vesselId=${vesselId}`);
    return queryParams.length > 0 ? '?' + queryParams.join('&') : '';
};
